import { Box, Image } from "@chakra-ui/react";
import React from "react";
import { IImageFluidItem } from "../models/fluidImage";
import { Else, If, Then } from "react-if";

interface Props {
  imageItem?: IImageFluidItem;
  children?: React.ReactNode;
  heightFluidImage?: string;
  // All other props
  [x: string]: any;
}

const FluidImage: React.FC<Props> = ({
  imageItem,
  children,
  heightFluidImage = "auto",
  ...rest
}) => {
  if (!imageItem || !imageItem.data) {
    return <Box w="100%" h="10" bg="grey50" />;
  }

  if (Object.keys(imageItem.data.attributes).length === 0) {
    return <Box w="100%" h="10" bg="grey50" />;
  }

  const { url, formats, width, height, alternativeText, caption } =
    imageItem.data.attributes;

  const srcSet: string[] = [];
  const webpSrcSet: string[] = [];
  const sizes: string[] = [];

  Object.entries(formats).forEach(([key, format]) => {
    srcSet.push(`${format.url} ${format.width}w`);
    webpSrcSet.push(`${format?.webp?.url} ${format?.webp?.width}w`);
    sizes.push(`(max-width: ${format.width}px) ${format.width}px`);
  });

  const srcSetString = srcSet.join(", ");
  const webpSrcSetString = webpSrcSet.join(", ");
  const sizesString = sizes.join(", ");

  return (
    <Box position="relative" width="100%" aspectRatio={`${width} / ${height}`}>
      <If condition={webpSrcSetString.length === 0}>
        <Then>
          <Image
            srcSet={srcSetString}
            src={url}
            alt={alternativeText}
            title={caption || "cdi product"}
            loading="lazy"
            width="100%"
            height={heightFluidImage}
            top="0"
            left="0"
            objectFit="cover"
            sizes={sizesString}
            fallbackSrc={`https://via.placeholder.com/${width}x${height}`}
            maxWidth="100%"
            maxHeight="100%"
            {...rest}
          />
        </Then>
        <Else>
          <picture
            style={{
              width: "100%",
              height: heightFluidImage ? heightFluidImage : "auto",
            }}
          >
            <source type="image/webp" srcSet={webpSrcSetString} />
            <Image
              srcSet={srcSetString}
              src={url}
              alt={alternativeText}
              title={caption || "cdi product"}
              loading="lazy"
              width="100%"
              height={heightFluidImage}
              top="0"
              left="0"
              objectFit="cover"
              sizes={sizesString}
              fallbackSrc={`https://via.placeholder.com/${width}x${height}`}
              maxWidth="100%"
              maxHeight="100%"
              {...rest}
            />
          </picture>
        </Else>
      </If>

      <Box
        position="absolute"
        top="50%"
        left="50%"
        transform="translate(-50%, -50%)"
        color="white"
      >
        {children}
      </Box>
    </Box>
  );
};

export default FluidImage;
